import React, { useRef } from "react";
import { Container } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import "./VehicleFeatureSection.css";
import { useTranslation } from "react-i18next";

export default function VehicleFeatureSection({ vehicle }) {
  const { t } = useTranslation();

  const sliderRef = useRef(null);
  const featureSlides = vehicle.featureSlides || [];

  if (!featureSlides.length) return null;

  const scrollByAmount = (direction) => {
    if (!sliderRef.current) return;
    const slider = sliderRef.current;

    // Scroll by half the slider width (approx. 2 cards in view on desktop)
    const scrollAmount = slider.getBoundingClientRect().width * 0.6;

    slider.scrollBy({
      left: direction === "right" ? scrollAmount : -scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <section className="vehicle-features section-spacing">
      <Container fluid>
        <div className="vehicle-features__header">
          <SectionTitle
            subtitle={t("vehicleFeatures.subtitle")}
            title={t("vehicleFeatures.title")}
          />

          <p className="brand-section-desc">{t("vehicleFeatures.tagline")}</p>
        </div>

        <div className="vehicle-features__slider-wrapper">
          <div className="vehicle-features__slider" ref={sliderRef}>
            {featureSlides.map((slide) => {
              const slideTitle = slide.titleKey ? t(slide.titleKey) : slide.title || "";
              const slideDesc = slide.descriptionKey
                ? t(slide.descriptionKey)
                : slide.description || "";

              return (
                <article
                  key={slide.id}
                  className="vehicle-features__slide"
                  style={
                    slide.imageSrc
                      ? {
                          backgroundImage: `linear-gradient(
                            to top,
                            rgba(0, 0, 0, 0.75),
                            rgba(0, 0, 0, 0.1)
                          ), url(${slide.imageSrc})`,
                        }
                      : undefined
                  }
                >
                  <div className="vehicle-features__slide-content">
                    <h3 className="vehicle-features__slide-title">{slideTitle}</h3>
                    <p className="vehicle-features__slide-desc">{slideDesc}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>

        <div className="text-center">
          <div className="vehicle-features__controls">
            <button
              type="button"
              className="vehicle-features__arrow"
              onClick={() => scrollByAmount("left")}
              aria-label={t("vehicleFeatures.ariaLeft")}
            >
              ‹
            </button>

            <button
              type="button"
              className="vehicle-features__arrow"
              onClick={() => scrollByAmount("right")}
              aria-label={t("vehicleFeatures.ariaRight")}
            >
              ›
            </button>
          </div>
        </div>
      </Container>
    </section>
  );
}